import React, { useContext } from 'react';
import { DirectionalHint, Image, ImageFit } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { defaultUserGovernanceConfig } from '@bingads-webui-campaign-react/multi-step-teaching-bubble';

import CopilotTeachingBubbleSubPageMenu from '../media/copilot-teaching-bubble-sub-page-menu.png';
import CopilotTeachingBubbleGlobalHeader from '../media/copilot-teaching-bubble-global-header.png';
import { getStyles } from './reporting-insights-teaching-bubble-styles';

export const ReportingInsightsStepOne = () => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className="reporting-insights-teaching-bubble-step-one">
      <Image
        styles={{ root: classes.screenshotContainer, image: classes.stepOneImage }}
        src={CopilotTeachingBubbleSubPageMenu}
        alt={i18n.getString(_TL_('Screenshot of Copilot Summarize button in page navigation'))}
        imageFit={ImageFit.cover}
      />
      <div>
        {i18n.getString(_TL_('Get AI-generated summaries and insights about your account or campaign performance. You can modify the scope of the summary by adjusting the navigation level filters, such as filtered campaigns, campaign type or by changing the date range.'))}
      </div>
    </div>
  );
};

export const ReportingInsightsStepTwo = () => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className="reporting-insights-teaching-bubble-step-two">
      <Image
        styles={{ root: classes.screenshotContainer, image: classes.stepTwoImage }}
        src={CopilotTeachingBubbleGlobalHeader}
        alt={i18n.getString(_TL_('Screenshot of Copilot button in site header'))}
        imageFit={ImageFit.cover}
      />
      <div>
        {i18n.getString(_TL_('You can ask Copilot for a comprehensive summary and key insights on your account or campaign performance. Just provide your campaign name and specify the date range you want to cover for the summary.'))}
      </div>
    </div>
  );
};

export const ReportingInsightsTeachingBubbleConfig = {
  featureName: 'reporting-insights-welcome',
  userGovernanceConfig: defaultUserGovernanceConfig,
  steps: [
    {
      title: _TL_('Get a quick summary with key insights for your account or campaign performance.'),
      content: (<ReportingInsightsStepOne />),
      primaryButtonText: _TL_('Try now'),
      secondaryButtonText: _TL_(''),
      targetElement: '.insights-button', // summary button
      directionalHint: DirectionalHint.rightTopEdge,
    },
    {
      title: _TL_('Ask Copilot for a quick campaign summary'),
      content: (<ReportingInsightsStepTwo />),
      primaryButtonText: _TL_('Try now'),
      secondaryButtonText: _TL_(''),
      targetElement: '.new-global-menu-copilot-button',
      directionalHint: DirectionalHint.rightTopEdge,
      onNext: () => {},
      // on click?
    },
  ],
};
